export default __webpack_public_path__ + "static/media/san-rafael-6.d42b21ae.jpg";